/**
 * Les Parisiennes — Forms Module
 * Storefront build 2026-07-18.2
 */
(function () {
  'use strict';
  var LP = window.LPTheme || {};
  var escapeHtml = LP.escapeHtml || function (str) { var d = document.createElement('div'); d.textContent = str; return d.innerHTML; };
  var isValidEmail = LP.isValidEmail || window.__lpIsValidEmail || function (email) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(email || '').trim()); };

  var activateFocusTrap = LP.activateFocusTrap || function () {};
  var deactivateFocusTrap = LP.deactivateFocusTrap || function () {};

  var _showToast = window._showToast || function () {};

  function registerInit(name, fn) {
    if (LP && typeof LP.registerInit === 'function') LP.registerInit(name, fn);
    else document.addEventListener('DOMContentLoaded', fn);
  }

  /* ============================================================
   * 17. NEWSLETTER FORM
   * ============================================================ */
  function initNewsletterForm() {
    document.querySelectorAll('#footer-newsletter, .newsletter-form').forEach(function (form) {
      if (form.__lpNewsletterBound) return;
      form.__lpNewsletterBound = true;
      form.addEventListener('submit', function (e) {
        var emailError = form.querySelector('.newsletter__error--email');
        var consentError = form.querySelector('.newsletter__error--consent');
        function setNewsletterError(el, text) {
          if (!el) return;
          el.textContent = text;
          el.classList.add('is-visible');
        }
        function clearNewsletterErrors() {
          [emailError, consentError].forEach(function (el) {
            if (!el) return;
            el.textContent = '';
            el.classList.remove('is-visible');
          });
        }
        clearNewsletterErrors();
        /* Check consent checkbox */
        var consent = form.querySelector('input[type="checkbox"][name*="consent"], .newsletter__consent input[type="checkbox"]');
        var newsletter = form.closest('.newsletter');
        var requireConsent = !newsletter || newsletter.dataset.requireConsent !== 'false';
        if (requireConsent && consent && !consent.checked) {
          e.preventDefault();
          var label = consent.closest('label') || consent.parentElement;
          if (label) { label.style.color = '#c62828'; setTimeout(function(){ label.style.color = ''; }, 2500); }
          setNewsletterError(consentError, (window.lpThemeStrings && window.lpThemeStrings.contactRequired) || 'This field is required.');
          consent.focus();
          return;
        }
        var emailInput = form.querySelector('input[type="email"]');
        if (!emailInput || !isValidEmail(emailInput.value)) {
          e.preventDefault();
          if (emailInput) {
            emailInput.focus();
            emailInput.setAttribute('aria-invalid', 'true');
            setNewsletterError(emailError, (window.lpThemeStrings && window.lpThemeStrings.contactEmailInvalid) || 'Please enter a valid email address.');
            setTimeout(function () { emailInput.removeAttribute('aria-invalid'); }, 2500);
          }
          return;
        }

      });
    });
  }

  function initContactValidation() {
    var form = document.getElementById('contact-form');
    if (!form) return;
    var invalidEmail = (window.lpThemeStrings && window.lpThemeStrings.contactEmailInvalid) || 'Please enter a valid email address.';
    var requiredText = (window.lpThemeStrings && window.lpThemeStrings.contactRequired) || 'This field is required.';

    function messageFor(field) {
      if (!field.id) field.id = 'field-' + Math.random().toString(36).slice(2);
      var id = field.id + '-error';
      var msg = document.getElementById(id);
      if (!msg) {
        msg = document.createElement('p');
        msg.id = id;
        msg.className = 'contact-form__error-message';
        field.insertAdjacentElement('afterend', msg);
      }
      var describedBy = String(field.getAttribute('aria-describedby') || '');
      if (describedBy.indexOf(id) === -1) field.setAttribute('aria-describedby', (describedBy + ' ' + id).trim());
      return msg;
    }

    function setError(field, message) {
      var msg = messageFor(field);
      field.setAttribute('aria-invalid', 'true');
      msg.textContent = message;
      msg.classList.add('is-visible');
    }

    function clearError(field) {
      var msg = field.id ? document.getElementById(field.id + '-error') : null;
      field.removeAttribute('aria-invalid');
      if (msg) {
        msg.textContent = '';
        msg.classList.remove('is-visible');
      }
    }

    form.querySelectorAll('input, select, textarea').forEach(function (field) {
      field.addEventListener('input', function () { clearError(field); });
      field.addEventListener('change', function () { clearError(field); });
    });

    form.addEventListener('submit', function (e) {
      var firstInvalid = null;
      form.querySelectorAll('[required]').forEach(function (field) {
        clearError(field);
        if (!String(field.value || '').trim()) {
          setError(field, requiredText);
          if (!firstInvalid) firstInvalid = field;
        } else if (field.type === 'email' && !isValidEmail(field.value)) {
          setError(field, invalidEmail);
          if (!firstInvalid) firstInvalid = field;
        }
      });
      if (firstInvalid) {
        e.preventDefault();
        firstInvalid.focus();
      }
    });
  }

  /* ============================================================
   * 18. COUNTRY / PROVINCE SELECTOR
   * ============================================================ */
  function initAddressSelectors() {
    if (typeof Shopify === 'undefined' || typeof Shopify.CountryProvinceSelector === 'undefined') return;
    document.querySelectorAll('select[name="address[country]"]').forEach(function (sel) {
      var id = sel.id;
      var provinceId = id.replace('country', 'province');
      new Shopify.CountryProvinceSelector(id, provinceId, { hideElement: provinceId + '-wrapper' });
    });
  }

  /* ============================================================
   * 19. SHOPIFY COOKIE PREFERENCES
   * ============================================================ */
  window.openCookiePreferences = function () {
    var attempts = 0;
    function openPreferences() {
      if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
        window.privacyBanner.showPreferences().catch(function () {
          _showToast((window.lpThemeStrings && window.lpThemeStrings.cookiePreferencesUnavailable) || 'Cookie preferences are temporarily unavailable.', 3500);
        });
        return;
      }
      attempts += 1;
      if (attempts < 20) {
        window.setTimeout(openPreferences, 150);
        return;
      }
      _showToast((window.lpThemeStrings && window.lpThemeStrings.cookiePreferencesUnavailable) || 'Cookie preferences are temporarily unavailable.', 3500);
    }
    openPreferences();
  };

  /* ============================================================
   * 19b. COUNTRY DETECTION WELCOME POPUP
   * ============================================================ */
  function _isExpired(key, days) {
    var stored = null;
    try { stored = localStorage.getItem(key); } catch (e) {}
    if (!stored) return true;
    var ts = parseInt(stored, 10);
    return (Date.now() - ts) > days * 86400000;
  }
  function _setWithTimestamp(key) {
    try { localStorage.setItem(key, String(Date.now())); } catch (e) {}
  }
  function _countryWelcomeKey(suggestedCountry) {
    var popup = document.getElementById('country-welcome');
    var current = popup ? String(popup.dataset.currentCountryCode || '').toUpperCase() : '';
    var suggested = String(suggestedCountry || (popup && popup.dataset.suggestedCountryCode) || '').toUpperCase();
    return current && suggested ? 'country-recommendation-dismissed-v2-' + current + '-' + suggested : 'country-recommendation-dismissed-v2';
  }
  function _hasManualCountrySelection() {
    return !_isExpired('lp-country-manual-selection', 30);
  }
  function _markManualCountrySelection() {
    _setWithTimestamp('lp-country-manual-selection');
  }
  function _cookieBannerIsBlocking() {
    try {
      return Boolean(
        window.Shopify &&
        window.Shopify.customerPrivacy &&
        typeof window.Shopify.customerPrivacy.shouldShowBanner === 'function' &&
        window.Shopify.customerPrivacy.shouldShowBanner()
      );
    } catch (e) {
      return false;
    }
  }
  function _customerPrivacyApiIsReady() {
    return Boolean(
      window.Shopify &&
      window.Shopify.customerPrivacy &&
      typeof window.Shopify.customerPrivacy.shouldShowBanner === 'function'
    );
  }
  function _runAfterCookieConsent(callback) {
    var handled = false;
    var attempts = 0;
    var readinessTimer = null;
    function finish() {
      if (handled) return;
      handled = true;
      if (readinessTimer) window.clearTimeout(readinessTimer);
      document.removeEventListener('visitorConsentCollected', resume);
      callback();
    }
    function resume() {
      if (handled || !_customerPrivacyApiIsReady() || _cookieBannerIsBlocking()) return;
      finish();
    }
    function checkReadiness() {
      if (handled) return;
      if (_customerPrivacyApiIsReady()) {
        if (!_cookieBannerIsBlocking()) finish();
        return;
      }
      attempts += 1;
      if (attempts >= 30) {
        finish();
        return;
      }
      readinessTimer = window.setTimeout(checkReadiness, 100);
    }
    document.addEventListener('visitorConsentCollected', resume);
    checkReadiness();
  }

  function _showCountryWelcome(popup) {
    if (!popup) return;
    if (_cookieBannerIsBlocking()) {
      _runAfterCookieConsent(function () { _showCountryWelcome(popup); });
      return;
    }
    popup.setAttribute('aria-hidden', 'false');
    window.requestAnimationFrame(function () { popup.classList.add('is-open'); });
    activateFocusTrap(popup.querySelector('.country-welcome__inner') || popup);
  }

  function _hideCountryWelcome(popup) {
    if (!popup) return;
    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
    deactivateFocusTrap(popup.querySelector('.country-welcome__inner') || popup);
  }

  function initCountryWelcome() {
    var popup = document.getElementById('country-welcome');
    if (!popup || _hasManualCountrySelection()) {
      _triggerNewsletterAfterCountry();
      return;
    }

    _runAfterCookieConsent(function () {
      var currentCountry = String(popup.dataset.currentCountryCode || '').toUpperCase();
      var routesRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || popup.dataset.routesRoot || '/';
      if (!currentCountry || typeof window.fetch !== 'function') {
        _triggerNewsletterAfterCountry();
        return;
      }
      var endpoint = routesRoot + 'browsing_context_suggestions.json?country[enabled]=true&country[exclude]=' + encodeURIComponent(currentCountry);
      fetch(endpoint, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (response) {
          if (!response.ok) throw new Error('Country recommendation unavailable');
          return response.json();
        })
        .then(function (payload) {
          var suggestions = payload && Array.isArray(payload.suggestions) ? payload.suggestions : [];
          var countryPart = suggestions[0] && suggestions[0].parts ? suggestions[0].parts.country : null;
          var detectedCountry = payload && payload.detected_values ? payload.detected_values.country : null;
          var suggestedCode = String((countryPart && (countryPart.handle || countryPart.iso_code)) || '').toUpperCase();
          var suggestedName = (countryPart && countryPart.name) || (detectedCountry && detectedCountry.name) || '';
          if (!suggestedCode || !suggestedName || suggestedCode === currentCountry || !_isExpired(_countryWelcomeKey(suggestedCode), 30)) {
            _triggerNewsletterAfterCountry();
            return;
          }
          popup.dataset.suggestedCountryCode = suggestedCode;
          var detectedName = popup.querySelector('[data-country-detected-name]');
          var suggestedNameEl = popup.querySelector('[data-country-suggested-name]');
          if (detectedName) detectedName.textContent = suggestedName;
          if (suggestedNameEl) suggestedNameEl.textContent = suggestedName;
          window.setTimeout(function () {
            _showCountryWelcome(popup);
          }, 300);
        })
        .catch(function () {
          _triggerNewsletterAfterCountry();
        });
    });
  }
  window.switchCountryRecommendation = function () {
    var popup = document.getElementById('country-welcome');
    var form = document.getElementById('country-recommendation-form');
    var codeInput = form ? form.querySelector('[data-country-recommendation-code]') : null;
    var returnTo = form ? form.querySelector('[data-localization-return-to]') : null;
    var suggestedCode = popup ? String(popup.dataset.suggestedCountryCode || '').toUpperCase() : '';
    if (!form || !codeInput || !suggestedCode) return;
    codeInput.value = suggestedCode;
    if (returnTo) returnTo.value = window.location.pathname + window.location.search + window.location.hash;
    _markManualCountrySelection();
    form.submit();
  };

  window.openCountrySelector = function () {
    var popup = document.getElementById('country-welcome');
    var localeDrawer = document.getElementById('locale-drawer');
    if (popup && popup.dataset.suggestedCountryCode) {
      _setWithTimestamp(_countryWelcomeKey(popup.dataset.suggestedCountryCode));
    }
    if (popup) {
      _hideCountryWelcome(popup);
    }
    if (localeDrawer && typeof window.toggleLocaleDrawer === 'function') {
      if (!localeDrawer.classList.contains('is-open')) window.toggleLocaleDrawer();
      return;
    }
    window.setTimeout(function () { _triggerNewsletterAfterCountry(); }, 800);
  };

  window.closeCountryWelcome = function () {
    var popup = document.getElementById('country-welcome');
    if (popup && popup.dataset.suggestedCountryCode) {
      _setWithTimestamp(_countryWelcomeKey(popup.dataset.suggestedCountryCode));
    }
    if (popup) {
      _hideCountryWelcome(popup);
    }
    window.setTimeout(function () { _triggerNewsletterAfterCountry(); }, 800);
  };
  /* ============================================================
   * 24. HELP WIDGET
   * ============================================================ */
  window.toggleHelpWidget = function () {
    var fab = document.getElementById('help-fab');
    var panel = document.getElementById('help-panel');
    if (!fab || !panel) return;
    var isOpen = panel.classList.contains('is-open');
    if (!isOpen) panel.hidden = false;
    panel.classList.toggle('is-open', !isOpen);
    fab.classList.toggle('is-active', !isOpen);
    panel.setAttribute('aria-hidden', isOpen ? 'true' : 'false');
    if (isOpen) {
      deactivateFocusTrap(panel);
      window.setTimeout(function () {
        if (!panel.classList.contains('is-open')) panel.hidden = true;
      }, 400);
    } else {
      activateFocusTrap(panel);
    }
  };

  function initHelpForm() {
    var form = document.getElementById('help-form');
    if (!form) return;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('.help-panel__submit');
      /* Enrich body with reason + name prepended */
      var reason = form.querySelector('[name="contact[reason]"]');
      var firstName = form.querySelector('[name="contact[first_name]"]');
      var lastName = form.querySelector('[name="contact[last_name]"]');
      var bodyField = form.querySelector('[name="contact[body]"]');
      var fileLink = form.querySelector('[name="contact[file_link]"]');
      if (btn) { btn.textContent = (window.lpThemeStrings && window.lpThemeStrings.sending) || 'Sending\u2026'; btn.disabled = true; }
      var orig = bodyField ? bodyField.value : '';
      var enriched = '';
      if (reason && reason.value) enriched += 'Reason: ' + reason.value + '\n';
      if (firstName || lastName) enriched += 'Name: ' + (firstName ? firstName.value : '') + ' ' + (lastName ? lastName.value : '') + '\n\n';
      if (fileLink && fileLink.value.trim()) enriched += 'File link: ' + fileLink.value.trim() + '\n';
      if (enriched) enriched += '\n';
      enriched += orig;
      if (bodyField) bodyField.value = enriched;
      var data = new FormData(form);
      if (bodyField) bodyField.value = orig; /* restore */
      fetch(LP.route('contact'), {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        body: data
      })
        .then(function (r) {
          if (r.ok) {
            form.innerHTML = '<div style="text-align:center;padding:var(--space-2xl) var(--space-lg)">' +
              '<div style="font-size:2rem;margin-bottom:var(--space-md)">\u2713</div>' +
              '<p style="font-size:var(--font-size-sm);color:var(--color-text)">' + escapeHtml((window.lpThemeStrings && window.lpThemeStrings.helpSendSuccess) || 'Your message has been sent.') + '</p>' +
              '</div>';
          } else { throw new Error('HTTP ' + r.status); }
        })
        .catch(function (err) {
          /* silent */
          if (btn) { btn.textContent = 'Send message'; btn.disabled = false; }
          _showToast((window.lpThemeStrings && window.lpThemeStrings.helpSendError) || 'We could not send your message. Please try again.', 4000);
        });
    });
  }
  /* ============================================================
   * 27. NEWSLETTER POPUP
   * ============================================================ */
  function setNewsletterPopupMode(popup, mode) {
    if (!popup) return;
    var isWaitlist = mode === 'waitlist';
    var title = popup.querySelector('.newsletter-popup__title');
	    var text = popup.querySelector('.newsletter-popup__text');
	    var tags = popup.querySelector('[data-newsletter-popup-tags]');
	    var shoeSizeField = popup.querySelector('[data-newsletter-popup-shoe-size-field]');
	    var shoeSizeSelect = popup.querySelector('[data-newsletter-popup-shoe-size]');
	    if (title) title.textContent = isWaitlist ? (popup.dataset.waitlistTitle || popup.dataset.defaultTitle || title.textContent) : (popup.dataset.defaultTitle || title.textContent);
	    if (text) text.textContent = isWaitlist ? (popup.dataset.waitlistText || popup.dataset.defaultText || text.textContent) : (popup.dataset.defaultText || text.textContent);
	    if (tags) tags.value = isWaitlist ? (popup.dataset.waitlistTags || 'newsletter, waitlist, hero') : (popup.dataset.defaultTags || 'newsletter');
	    if (shoeSizeField) shoeSizeField.hidden = !isWaitlist;
	    if (shoeSizeSelect) {
	      var shoeSizeRequired = shoeSizeSelect.dataset.required === 'true';
	      shoeSizeSelect.disabled = !isWaitlist;
	      shoeSizeSelect.required = isWaitlist && shoeSizeRequired;
	      if (!isWaitlist) {
	        shoeSizeSelect.value = '';
	        shoeSizeSelect.removeAttribute('aria-invalid');
	      }
	    }
	    popup.classList.toggle('newsletter-popup--waitlist', isWaitlist);
	  }

  function resetNewsletterPopup(popup) {
    if (!popup) return;
    var formWrap = document.getElementById('newsletter-popup-form');
    var success = document.getElementById('newsletter-popup-success');
    var form = document.getElementById('popup-subscribe-form');
    var error = popup.querySelector('[data-newsletter-popup-error]');
    if (formWrap) formWrap.style.display = '';
    if (success) success.style.display = 'none';
    if (form) {
	      var submit = form.querySelector('button[type="submit"]');
	      var email = form.querySelector('input[name="contact[email]"]');
	      var consent = form.querySelector('[data-newsletter-popup-consent]');
	      var shoeSize = form.querySelector('[data-newsletter-popup-shoe-size]');
	      if (submit) submit.disabled = false;
	      if (email) {
	        email.removeAttribute('aria-invalid');
	        email.style.outline = '';
	      }
	      if (shoeSize) {
	        shoeSize.value = '';
	        shoeSize.removeAttribute('aria-invalid');
	      }
	      if (consent) {
	        consent.checked = false;
	        consent.removeAttribute('aria-invalid');
      }
    }
    if (error) {
      error.textContent = '';
      error.classList.remove('is-visible');
    }
  }

  function closeBlockingPopupsForNewsletter() {
    var countryPopup = document.getElementById('country-welcome');
    if (countryPopup && countryPopup.getAttribute('aria-hidden') === 'false') {
      if (countryPopup.dataset.suggestedCountryCode) {
        _setWithTimestamp(_countryWelcomeKey(countryPopup.dataset.suggestedCountryCode));
      }
      _hideCountryWelcome(countryPopup);
    }
    var localeModal = document.getElementById('locale-drawer');
    var localeOverlay = document.getElementById('locale-overlay');
    if (localeModal) {
      localeModal.classList.remove('is-open');
      localeModal.setAttribute('aria-hidden', 'true');
      localeModal.hidden = true;
      deactivateFocusTrap(localeModal);
    }
    if (localeOverlay) {
      localeOverlay.classList.remove('is-open');
      localeOverlay.hidden = true;
    }
  }

  window.openNewsletterPopup = function (options) {
    var opts = options || {};
    var popup = document.getElementById('newsletter-popup');
    if (!popup) return;
    if (!opts.manual && popup.dataset.enabled === 'false') return;
    if (!opts.manual && popup.dataset.autoSuppressed === 'true') return;
    if (!opts.manual && (_cookieBannerIsBlocking() || _hasBlockingOverlay())) return;
    if (popup.style.display === 'flex' && popup.getAttribute('aria-hidden') === 'false') return;
    if (opts.manual) closeBlockingPopupsForNewsletter();
    setNewsletterPopupMode(popup, opts.mode || 'newsletter');
    resetNewsletterPopup(popup);
    popup.hidden = false;
    popup.style.display = 'flex';
    popup.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var inner = popup.querySelector('.newsletter-popup__inner') || popup;
    var email = popup.querySelector('input[name="contact[email]"]');
    activateFocusTrap(inner, email);
  };

  function _triggerNewsletterAfterCountry() {
    var popup = document.getElementById('newsletter-popup');
    if (!popup || popup.dataset.enabled === 'false' || popup.dataset.autoSuppressed === 'true') return;
    if (_cookieBannerIsBlocking()) {
      _runAfterCookieConsent(_triggerNewsletterAfterCountry);
      return;
    }
    var frequencyDays = parseInt(popup.dataset.frequencyDays || '30', 10) || 30;
    var delay = Math.max(parseInt(popup.dataset.delay || '45000', 10) || 45000, 30000);
    if (!_isExpired('lp-popup-shown-v2', frequencyDays)) return;
    if (popup.dataset.autoScheduled === 'true') return;
    popup.dataset.autoScheduled = 'true';
    setTimeout(function () {
      popup.dataset.autoScheduled = 'false';
      if (!_isExpired('lp-popup-shown-v2', frequencyDays)) return;
      if (_cookieBannerIsBlocking() || _hasBlockingOverlay()) {
        window.setTimeout(_triggerNewsletterAfterCountry, 3000);
        return;
      }
      window.openNewsletterPopup({ mode: 'newsletter' });
    }, delay);
  }

  function _hasBlockingOverlay() {
    var countryPopup = document.getElementById('country-welcome');
    var localeModal = document.getElementById('locale-drawer');
    var helpPanel = document.getElementById('help-panel');
    var mobileNav = document.getElementById('mobile-nav');
    return Boolean(
      (countryPopup && countryPopup.getAttribute('aria-hidden') === 'false') ||
      (localeModal && localeModal.classList.contains('is-open')) ||
      (helpPanel && helpPanel.classList.contains('is-open')) ||
      (mobileNav && mobileNav.classList.contains('is-open'))
    );
  }

  function initNewsletterPopup() {
    /* Newsletter popup is now triggered by country welcome flow.
       If country welcome isn't present, it'll fire via initCountryWelcome fallback. */
  }

  window.closeNewsletterPopup = function () {
    _setWithTimestamp('lp-popup-shown-v2');
    var popup = document.getElementById('newsletter-popup');
    if (popup) {
      popup.style.display = 'none';
      popup.hidden = true;
      popup.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      deactivateFocusTrap(popup.querySelector('.newsletter-popup__inner') || popup);
    }
  };

  function initPopupSubscribe() {
    var form = document.getElementById('popup-subscribe-form');
    if (!form || form.__lpPopupSubscribeBound) return;
    form.__lpPopupSubscribeBound = true;
    if (window.location.hash === '#popup-subscribe-form' && form.querySelector('[data-newsletter-result]')) {
      window.openNewsletterPopup({ manual: true });
      if (form.querySelector('[data-newsletter-result="success"]')) _showPopupSuccess();
    }
    form.addEventListener('submit', function (e) {
	      var emailInput = form.querySelector('input[name="contact[email]"]');
	      var consentInput = form.querySelector('[data-newsletter-popup-consent]');
	      var shoeSizeInput = form.querySelector('[data-newsletter-popup-shoe-size]:not(:disabled)');
	      var error = form.querySelector('[data-newsletter-popup-error]');
      function setPopupError(message) {
        if (!error) return;
        error.textContent = message;
        error.classList.add('is-visible');
      }
      if (error) {
        error.textContent = '';
        error.classList.remove('is-visible');
      }
      if (consentInput && !consentInput.checked) {
        e.preventDefault();
        consentInput.setAttribute('aria-invalid', 'true');
        consentInput.focus();
        setPopupError((window.lpThemeStrings && window.lpThemeStrings.contactRequired) || 'Please accept the email consent.');
        return;
      }
	      if (!emailInput || !isValidEmail(emailInput.value)) {
          e.preventDefault();
	        if (emailInput) { emailInput.focus(); emailInput.style.outline = '1px solid #e55'; }
	        setPopupError((window.lpThemeStrings && window.lpThemeStrings.contactEmailInvalid) || 'Please enter a valid email address.');
	        return;
	      }
	      if (shoeSizeInput && shoeSizeInput.required && !shoeSizeInput.value) {
          e.preventDefault();
	        shoeSizeInput.setAttribute('aria-invalid', 'true');
	        shoeSizeInput.focus();
	        setPopupError((window.lpThemeStrings && window.lpThemeStrings.contactRequired) || 'Please complete the required fields.');
	        return;
	      }

    });
  }

  function _showPopupSuccess() {
    var formEl = document.getElementById('newsletter-popup-form');
    var successEl = document.getElementById('newsletter-popup-success');
    if (formEl) formEl.style.display = 'none';
    if (successEl) successEl.style.display = 'flex';
    _setWithTimestamp('lp-popup-shown-v2');
  }

  registerInit('initNewsletterForm', initNewsletterForm);
  registerInit('initContactValidation', initContactValidation);
  registerInit('initAddressSelectors', initAddressSelectors);
  registerInit('initCountryWelcome', initCountryWelcome);
  registerInit('initHelpForm', initHelpForm);
  registerInit('initNewsletterPopup', initNewsletterPopup);
  registerInit('initPopupSubscribe', initPopupSubscribe);
}());
